/// <reference path='../../../../../typings/index.d.ts' />
/// <reference path='../controls.module.ts' />

module Meevo.Components.Controls {
    'use strict';
    import ICustomControlsModel = Meevo.Components.BaseClasses.ICustomControlsModel;

    interface IMeevoCustomControlsScope extends angular.IScope {
        model: ICustomControlsModel,
        controls: Array<Meevo.Model.IUserDefinedControl>,
        locked: boolean,
        appAreaEnum: Meevo.Model.AppAreaEnum,
        entityId: Guid | string,
        hideHeader: boolean,
        headerText: string
    }

    export class MeevoCustomControls implements angular.IDirective {
        restrict = 'E';
        scope = {
            model: '=',
            controls: '=',
            locked: '=',
            entityId: '=',
            appAreaEnum: '=',
            hideHeader: '@?',
            headerText: '@?',
            tabIndex: "=?"
        };
        templateUrl = 'app/components/controls/customControls/customControlsTemplate.html';
        bindToController = true;
        controller = Meevo.Components.Controls.CustomControlsController;
        controllerAs = '$ctrl';
        require = [
            'meevoCustomControls', // self controller
        ];

        link = (scope: IMeevoCustomControlsScope, element: JQuery, attr: angular.IAttributes, [self, ngModel]) => {
            self.init();
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoCustomControls();
            };

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoCustomControls', MeevoCustomControls.factory())
        .directive('meevoCheckboxGroupValidity', () => {
            return {
                scope: {
                    checkboxGroupRequired: '=',
                    model: '=ngModel'
                },
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, elem, attributes: ng.IAttributes, ngModel: ng.INgModelController){

                    scope.$watch('model', (value: Array<boolean>) => {
                        if (scope['checkboxGroupRequired']) {
                            let valid: boolean = false;

                            if (value && value.length) {
                                valid = value.indexOf(true) > -1;
                                ngModel.$setValidity('required', valid);
                            } else {
                                ngModel.$setValidity('required', false);
                            }
                        }
                    }, true);

                }
            }
        });
}